import { useState } from 'react';
import {
  Slider,
  SliderTrack,
  SliderMark,
  SliderFilledTrack,
  SliderThumb,
  Tooltip,
  Text,
} from '@chakra-ui/react';

const SliderInput = ({
  title = null,
  min,
  max,
  def,
  onchangeend,
  sliderMark = 'false',
  tooltip = 'true',
  step = 1,
}) => {
  const [sliderValue, setSliderValue] = useState(Number(def));
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <>
      {title && <Text textStyle="h6">{title}</Text>}

      <Slider
        id="slider"
        defaultValue={Number(def)}
        min={Number(min)}
        max={Number(max)}
        colorScheme="secondary"
        onChange={(v) => setSliderValue(v)}
        onChangeEnd={onchangeend}
        step={Number(step)}
        onMouseEnter={() =>
          tooltip === 'true' ? setShowTooltip(true) : setShowTooltip(false)
        }
        onMouseLeave={() => setShowTooltip(false)}
      >
        {sliderMark && (
          <SliderMark
            value={sliderValue}
            mt="16px"
            ml="-16px"
            bg="white"
            textStyle="h6"
          >
            {sliderValue}
          </SliderMark>
        )}
        <SliderTrack>
          <SliderFilledTrack />
        </SliderTrack>
        <Tooltip
          hasArrow
          bg="teal.500"
          color="white"
          placement="bottom"
          isOpen={showTooltip}
          label={`£${sliderValue}`}
        >
          <SliderThumb />
        </Tooltip>
      </Slider>
    </>
  );
};

export default SliderInput;
